<phdsoft-sideboard [options]="optionsWindow" class="rs-matrix-window" (cancel)="closeWindow()">
  <div content class="risk-assessment-content" *ngIf="!isLoadingComponentData">
    <div class="risk-matrix">
      <table>
        <thead>
          <tr>
            <th></th>
            <th *ngFor="let consequence of riskMatrix.consequenceItems">{{ consequence.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let pof of riskMatrix.probabilityOfFailureItems">
            <th>{{ pof.name }}</th>
            <td
              *ngFor="let consequence of riskMatrix.consequenceItems"
              [style.background-color]="getCellColor(consequence.id, pof.id)"
              [style.color]="'black'"
              [class.selected-cell]="isSelectedCell(consequence.id, pof.id)"
              (click)="onCellClick(consequence.id, pof.id)"
            >
              {{ getCellContent(consequence.id, pof.id) || 0 }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <!-- New row with a single cell that spans all columns -->
          <tr>
            <th class="table-cell-row">Unrated</th>
            <td
              class="unrated-table-cell"
              [style.background-color]="'#B0E0E6'"
              [attr.colspan]="riskMatrix.consequenceItems.length"
              [class.selected-cell]="isUnratedSelected()"
              (click)="onUnratedClick()"
            >
              {{ matrixData.unratedRegions.length }}
            </td>
          </tr>
        </tfoot>
      </table>
      <div class="risk-level-legend">
        <span *ngFor="let riskLevel of riskMatrix.riskLevelItems" class="risk-level-item">
          <span
            class="risk-level-indicator"
            [ngStyle]="{'background-color': riskLevel.color}"
          ></span>
          <span class="risk-level-name">{{ riskLevel.name }}</span>
        </span>
      </div>
    </div>

    <!-- <div>
      <button (click)="loadAllRegions()">Load all regions</button>
    </div> -->

    <div class="risk-matrix-list-container">
      <ul class="risk-matrix-region-list">
        <li
          class="risk-matrix-region-item"
          *ngFor="let region of consolidatedRegionsRiskFiltered; trackBy: trackByFn"
        >
          <div
            class="risk-matrix-region-header"
            [class.selected]="currentSelectedRegion === region"
            [class.expanded]="region.expanded"
            tabindex="0"
            (click)="handleClickRegion(region)"
          >
            <mat-icon class="expand-icon" aria-hidden="true">
              {{ region.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
            </mat-icon>
            <span class="region-name">{{ region.name }}</span>
            <span
              class="risk-level-indicator"
              [ngStyle]="{'background-color': region.riskLevelColor}"
            ></span>
          </div>
          <ul class="section-list" *ngIf="region.expanded">
            <li class="section-item" *ngFor="let section of region.sections">
              <div
                class="section-header"
                [class.expanded]="section.expanded"
                tabindex="0"
                (click)="handleClickSection(region, section)"
              >
                <mat-icon class="expand-icon" aria-hidden="true">
                  {{ section.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                </mat-icon>
                <span class="section-name">{{ section.name }}</span>
                <span
                  class="risk-level-indicator"
                  [style.background-color]="section.riskLevelColor"
                ></span>
              </div>
              <ul class="critical-area-list" *ngIf="section.expanded">
                <li class="critical-area-item" *ngFor="let criticalArea of section.criticalAreas">
                  <div
                    class="critical-area-header"
                    [class.expanded]="criticalArea.expanded"
                    tabindex="0"
                    (click)="handleClickCriticalArea(section,criticalArea)"
                  >
                    <mat-icon class="expand-icon" aria-hidden="true">
                      {{
                        criticalArea.expanded
                          ? 'keyboard_arrow_down'
                          : 'keyboard_arrow_right'
                      }}
                    </mat-icon>
                    <span class="critical-area-name">{{ criticalArea.name }}</span>
                    <span
                      class="risk-level-indicator"
                      [style.background-color]="criticalArea.riskLevelColor"
                    ></span>
                  </div>
                  <div class="critical-area-details" *ngIf="criticalArea.expanded">
                    <div class="detail-row">
                      <span class="detail-label">Consequence</span>
                      <span class="detail-value">
                        {{
                          getConsequenceName(criticalArea?.highestReason?.consequenceId) || 'N/A'
                        }}
                      </span>
                    </div>
                    <div class="detail-row">
                      <span class="detail-label">PoF</span>
                      <span class="detail-value">
                        {{
                          getPofName(criticalArea?.highestReason?.probabilityOfFailureId) || 'N/A'
                        }}
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
  <div content class="risk-assessment-loading" *ngIf="isLoadingComponentData">
    <mat-spinner style="margin:auto; transform: scale(0.5);"></mat-spinner>
  </div>
  <ng-container footer> </ng-container>
</phdsoft-sideboard>
